const NotificationTypes = ["project", "task", "user"];

export default NotificationTypes;
